/**
 * 功能使用统计公用服务
 * Bai.Zhiming
 * 2019-6-26
 */

angular.module('featureUsageStatisticsServiceModule', ['featureUsageStatisticsBindEventModule']).factory('featureUsageStatisticsService', ['$q', '$modal', 'modalDialog', 'trsHttpService',
    function($q, $modal, modalDialog, trsHttpService) {
        return {

            /**
             * [httpServer description]埋码管理，接口请求  增加拦截规则
             *
             * @param  {[type]}  url   [url description]
             * @param  {[type]}  params   [params description]
             * @param  {[type]}  method   [method description]
             * @param  {[type]}  forbidden   [forbidden description]
             *
             * @return  {[type]}   [return description]
             */
            httpServer(url, params, method, forbidden) {
                let deffer = $q.defer();
                trsHttpService.httpServer(url, params, method, forbidden).then((resp) => {
                    if (angular.isObject(resp) && resp.success == false) {
                        if (forbidden) {
                            deffer.reject(resp);
                        } else {
                            modalDialog.alertType(resp.message, '', 'error', 'confirm', () => {
                                deffer.reject(resp);
                            });
                        }
                    } else {
                        deffer.resolve(resp);
                    }
                }, (resp) => {
                    deffer.reject(resp);
                });
                return deffer.promise;
            },

            /**
             * [bindEvent description] 点击方法名弹出修改事件弹框
             *
             * @param  {[type]}  data   [item description]
             *
             * @return  {[type]}   [return description]
             */
            bindEvent(data) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/logManageMent/featureUsageStatistics/service/bindEvent/bindEvent.html',
                    windowClass: 'advanced-search',
                    backdrop: false,
                    controller: 'featureUsageStatisticsBindEventCtrl',
                    resolve: {
                        data: function() {
                            return data;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function(result) {
                    defer.reject(result);
                });
                return defer.promise;
            }
        };
    }
]);
